import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { initConnection } from "@/services/connection"
import { checkTradingGatewayCompatibility } from "@/services/tradingGatewayCompatibility"

import { App } from "./App/App"
import { ThemeProvider as MuiThemeProvider } from "./App/Equities/shared/components"
import { startTearOutWindows } from "./App/TearOutSection/tearOutSection.windows"
import { showCacheUpdateModal } from "./pwa/cacheUpdateModal"
import { register } from "./pwa/serviceWorkerRegistration"
import { ThemeProvider } from "./theme"
import { log } from "./utils"

if (import.meta.env.PROD) {
  log.debug("Register service worker")
  register({
    onUpdate: () => {
      // The update process has been extensively tested now
      // If it reaches this stage, then the registration method has waited for a new SW to be installed
      // and we are now ready to trigger a refresh to run the new components
      // (which are in the cache waiting to be activated)
      log.debug(
        "Service worker onUpdate - should now be activated - show update modal",
      )
      showCacheUpdateModal()
    },
  })
}

initConnection()
checkTradingGatewayCompatibility()
startTearOutWindows()

const container = document.getElementById("root")
const root = createRoot(container as HTMLElement)

root.render(
  <StrictMode>
    <ThemeProvider>
      <MuiThemeProvider>
        <App />
      </MuiThemeProvider>
    </ThemeProvider>
  </StrictMode>,
)
